import { Monsters } from './monsters';
import { Bosses } from './bosses';

export const Enemies = Bosses.concat(Monsters);